/*
 * @Description: 职能快捷退单
 * @Author: 杨志航
 * @Date: 2026-05-08 17:06:47
 */
import React, { useState, useEffect } from 'react'
import api from 'api'
import {
  Table,
  Form,
  Input,
  Button,
  Select,
  Alert,
  Spin,
} from 'antd'
import Auth from '@/components/AuthMiddleware'
import { allTrim, filterParams, cryptoParamsIntoUrl, getExport } from '@/utils'
import { Link } from 'react-router-dom'

const { Column } = Table
const FormItem = Form.Item
const Option = Select.Option
const typeList = [
  { id: 0, name: '直销订单'},
  { id: 1, name: '代理商订单'},
]

let pageSize = 10
let currentPage = 1
let searchParams = {
  limit: pageSize, 
  page: currentPage,
}

const Main = props => {
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue, getFieldsValue } = props.form
  const { history, match } = props
  const [count, setCount] = useState(0)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [spinLoading, setSpinLoading] = useState(false)
  const [authList, setAuthList] = useState([])
  const [auditStatusList, setAuditStatusList] = useState([])

  useEffect(() => {
    resetParams()
    getSearchData()
    getPageAuth()
    getList()
  }, [])

  const getSearchData = () => {
    Promise.all([
      api.getAuditStatusList({ type: 55 }),
    ]).then(list => {
      setAuditStatusList(list[0])
    })
  }

  //按钮权限
  const getPageAuth = () => {
    api.getPageAuth().then(list => {
      setAuthList(list)
    })
  }

  const resetParams = () => {
    searchParams = {
      limit: pageSize, 
      page: currentPage,
    }
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  //获取列表
  const getList = () => {
    setLoading(true)
    api.getQuickRefundOrderList(searchParams).then(res => {
      const { list, count } = res
      setList(list)
      setCount(count)
      setLoading(false)
    }).catch(() => { setLoading(false) })
  }

  //重置
  const onReset = () => {
    resetFields()
    currentPage = 1
    resetParams()
    getList()
  }

  //提交
  const formSubmit = evt => {
    evt.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals = filterParams(vals)
        currentPage = 1
        resetParams()
        searchParams = {...searchParams, ...vals}
        getList()
      }
    })
  }
  //点击分页
  const onChangeTable = (pagination, filters, sorter) => {
    searchParams.page = currentPage = pagination.current
    searchParams.limit = pageSize = pagination.pageSize
    getList()
  }

  // 导出
  const exportFile = () => {
    let params = JSON.parse(JSON.stringify(searchParams))
    delete params.limit
    delete params.page
    setSpinLoading(true)
    getExport('/fortune/order/ExportRefundOrderList', params).then(() => {
      setSpinLoading(false)
    }).catch(() => setSpinLoading(false))
  }

  return <>
    <Spin spinning={spinLoading}>
      <div className="search-doc-wrap">
        <Form onSubmit={formSubmit} {...formItemLayout} style={{ paddingTop: '10px' }}>
          <div className="form-box">
            <FormItem label="类型">
              {getFieldDecorator('type')(<Select 
                placeholder="请选择"
                allowClear
              >
                {
                  typeList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
                }
              </Select>)}
            </FormItem>
            <FormItem label="厂商ID">
              {getFieldDecorator('vendor')(<Input placeholder="请输入厂商ID" />)}
            </FormItem>
            <FormItem label="订单负责人">
              {getFieldDecorator('currentUserName')(<Input placeholder="请输入姓名" />)}
            </FormItem>
            <FormItem label="订单负责人员工编号">
              {getFieldDecorator('currentUserNumber')(<Input placeholder="请输入员工编号" />)}
            </FormItem>
            <FormItem label="审批状态">
              {getFieldDecorator('auditStatus')(<Select 
                placeholder="请选择"
                allowClear
                showSearch
                optionFilterProp="children"
              >
                {
                  auditStatusList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
                }
              </Select>)}
            </FormItem>
            <FormItem label="订单编号">
              {getFieldDecorator('number')(<Input placeholder="请输入订单编号" />)}
            </FormItem>
          </div>
          <FormItem className="btns" label=" " colon={false}>
            <Button type="primary" htmlType="submit">查询</Button>
            <Button onClick={onReset}>重置</Button>
          </FormItem>
        </Form>
      </div>
      <div className="line"></div>
      <div>
        <div className="add-wrap">
          <Auth auths={authList} code="order-refund-query">
            <Button type="primary" onClick={() => history.push('/orderManage/quickRefund/refundinfo')}>退单信息查询与提交</Button>
          </Auth>
          <Auth auths={authList} code="export">
            <Button type="primary" onClick={exportFile} style={{ marginLeft: 15 }}>数据导出</Button>
          </Auth>
        </div>
        <Alert className="corp-count" message={`总计：${count}条数据`} type="info" showIcon />
        <Table
          size="small"
          dataSource={list}
          rowKey={(record, index) => index}
          loading={loading}
          pagination={{
            pageSize,
            total: count,
            current: currentPage,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
          }}
          onChange={onChangeTable}
          scroll={{ x: 'max-content' }}
        >
          <Column 
            title="序号" 
            dataIndex="id"
            render={(text, record, index) => count - ((currentPage - 1) * pageSize + index)} 
          />
          <Column title="厂商ID" dataIndex="vendor" />
          <Column title="订单负责人" dataIndex="currentUserName" />
          <Column title="订单负责人员工编号" dataIndex="currentUserNumber" />
          <Column title="退单市场价" dataIndex="refundMarketPrice" />
          <Column title="退实收" dataIndex="refundActualPrice" />     
          <Column title="系统撤资日期" dataIndex="exitDate" />
          <Column 
            title="附件" 
            dataIndex="quickRefundAppendix" 
            render={(text, record) => (
              <>
                {text && JSON.parse(text).map((item, index) => <div key={index}><a href={item.url} target="_blank">{item.name}</a></div>)}
              </>
            )} 
          />
          <Column title="备注" dataIndex="remark" />
          <Column 
            title="退单订单编号" 
            dataIndex="numbers" 
            render={(text, record) => (
              <>
                {text && JSON.parse(text).map((item, index) => (
                  <div key={index}>
                    <Link to={cryptoParamsIntoUrl('/orderDirect/refundDetail', { id: item.id })} target="_blank">
                      {item.number}
                    </Link>
                  </div>
                ))}
              </>
            )}
          />
          <Column title="项目" dataIndex="projectName" />
          <Column title="产品" dataIndex="productName" />
          <Column title="审批状态" dataIndex="refundStatus" />
          <Column title="退单申请人" dataIndex="applicantName" />
          <Column title="申请时间" dataIndex="appliedate" />
          <Column title="通过时间" dataIndex="auditTime" />
        </Table>
      </div>
    </Spin>
  </>
}

export default Form.create()(Main)
